import { render, staticRenderFns } from "./BlockBaseForm.vue?vue&type=template&id=8e9335d4&scoped=true&"
import script from "./BlockBaseForm.vue?vue&type=script&lang=ts&"
export * from "./BlockBaseForm.vue?vue&type=script&lang=ts&"
import style0 from "./BlockBaseForm.vue?vue&type=style&index=0&id=8e9335d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9335d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VForm,VIcon,VSpacer})
